import React from 'react';
import Panel from '../../commons/panel';
import DatosFacturacion from './datos-compra/datos-facturacion';
import ListaPasajeros from './datos-compra/lista-pasajeros';

const DatosComunes = (props) => {

  let cuotas = '';
  if (props.formaPago !== 'deposito') {
    cuotas = (
      <div>
        <h4>
          Cuotas:
          <span>{props.cuotas}</span>
        </h4>
      </div>
    );
  }

  const precio = props.total.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');

  return (
    <div>
      <DatosFacturacion
        reservaId={props.reservaId}
        datosFacturacion={props.datosPago.DatosFacturacion}
        pasajeros={props.pasajeros}
        datosContacto={props.datosPago.DatosContacto}
      />
      <div className='row'>
        <div className='col-md-6'>
          <Panel>
            <h2 className='titulo-panel'>
              Datos de los pasajeros
            </h2>
            <div className='row'>
              {props.pasajeros === '' ? (
                ''
              ) : (
                <ListaPasajeros pasajeros={props.pasajeros} />
              )}
            </div>
          </Panel>
        </div>
        <div className='col-md-6'>
          <Panel>
            <h2 className='titulo-panel'>Resumen</h2>
            <div>
              <h4>
                Forma de pago elegida:
                <span>{props.formaPago}</span>
              </h4>
            </div>
            <div>
              <h4>
                Total:
                <b>
                  <span style={{ fontSize: 13 }}>
                    {/*props.moneda*/}
                    {' '}
                  </span>
                  <span>{precio}</span>
                </b>
              </h4>
            </div>
            {cuotas}
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default DatosComunes;
